/* eslint-disable no-console */
import { datadogLogs } from '@datadog/browser-logs';

// if (import.meta.env.VITE_ENV === 'production')
datadogLogs.init({
  clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN as string,
  site: import.meta.env.VITE_DATADOG_SITE,
  service: import.meta.env.VITE_DATADOG_SERVICE_NAME,
  env: import.meta.env.VITE_ENV,
  forwardErrorsToLogs: true,
  sampleRate: 100,
});

export default datadogLogs;
